/**
 * Product page functionality
 * Handles size selection, variant switching, add to cart, and lightbox
 */

document.addEventListener('DOMContentLoaded', function() {
  // Lightbox functionality
  initLightbox();
  // Gallery drag to scroll
  initGalleryDrag();
  var productRoot = document.querySelector('.product-page');
  var variantSelector = document.getElementById('variant-selector');
  var addToCartBtn = document.querySelector('.add-to-cart-btn');
  if (!productRoot || !variantSelector || !addToCartBtn) return;

  var productId = productRoot.getAttribute('data-product-id');
  var productHandle = productRoot.getAttribute('data-product-handle');
  var productAvailable = productRoot.getAttribute('data-product-available') === 'true';
  var variantsScript = document.getElementById('ProductVariants-' + productId);
  var translationsScript = document.getElementById('ProductTranslations-' + productId);
  var translations = { add_to_cart: 'Add to cart', out_of_stock: 'Out of stock' };
  try {
    if (translationsScript && translationsScript.textContent) {
      translations = JSON.parse(translationsScript.textContent);
    }
  } catch (e) {}
  var variants = [];
  try {
    if (variantsScript && variantsScript.textContent) {
      variants = JSON.parse(variantsScript.textContent);
      // Align with Dawn: rely solely on server-rendered variant.available
      productAvailable = Array.isArray(variants) && variants.some(function(v){ return !!v.available; });
      productRoot.setAttribute('data-product-available', String(productAvailable));
    }
  } catch (e) {}

  // Fallback/hydration: fetch real-time product JSON from Shopify AJAX API
  // Dawn approach: no AJAX hydration; rely on server-rendered data only
  function hydrateVariantsFromAjax() { return Promise.resolve(); }

  function fetchVariantById(id) {
    return fetch('/variants/' + id + '.json', { cache: 'no-cache' })
      .then(function(r){ return r.ok ? r.json() : Promise.reject('HTTP ' + r.status); })
      .then(function(data){ return data && data.variant ? data.variant : null; })
      .catch(function(e){ return null; });
  }

  function hydrateVariantsViaIds(ids) {
    return Promise.all(ids.map(fetchVariantById)).then(function(list){
      return list.filter(Boolean).map(function(v){
        return { id: v.id, title: v.title, available: !!v.available, inventory_quantity: v.inventory_quantity, inventory_policy: v.inventory_policy, option1: v.option1, option2: v.option2, option3: v.option3 };
      });
    });
  }

  var optionGroups = document.querySelectorAll('.variation-group');
  var optionButtons = document.querySelectorAll('.variation-option');
  var priceEl = document.getElementById('product-price');
  var compareEl = document.getElementById('product-compare-price');
  var priceContainer = document.querySelector('.product-price');

  function isBuyable(variant) {
    if (!variant) return false;
    return !!variant.available;
  }

  // Helper: get current variant from select
  function getCurrentVariant() {
    var id = variantSelector.value;
    var match = variants.find(function(v) { return String(v.id) === String(id); });
    return match || variants.find(function(v) { return v.available; }) || variants[0] || null;
  }

  function updatePriceUI(variant) {
    if (!variant) return;
    
    // Hide price container if variant is out of stock
    if (priceContainer) {
      if (variant.available) {
        priceContainer.style.display = '';
      } else {
        priceContainer.style.display = 'none';
        return;
      }
    }
    
    if (!priceEl || !compareEl) return;
    var priceText = variant.price_formatted || '';
    var compareText = variant.compare_at_price_formatted || '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceEl.textContent = priceText;
      priceEl.classList.add('price-amount--sale');
      compareEl.textContent = compareText;
      compareEl.style.display = '';
    } else {
      priceEl.textContent = priceText || priceEl.textContent;
      priceEl.classList.remove('price-amount--sale');
      compareEl.textContent = '';
      compareEl.style.display = 'none';
    }
  }

  // Initialize selected options from current variant
  var currentVariant = getCurrentVariant();
  var selectedOptions = [];
  if (currentVariant) {
    if (currentVariant.option1) selectedOptions[0] = currentVariant.option1;
    if (currentVariant.option2) selectedOptions[1] = currentVariant.option2;
    if (currentVariant.option3) selectedOptions[2] = currentVariant.option3;
  }

  function findMatchingVariant(optionsArr) {
    if (!variants || variants.length === 0) return null;
    return variants.find(function(v) {
      var o1 = optionsArr[0] == null || v.option1 === optionsArr[0];
      var o2 = optionsArr[1] == null || v.option2 === optionsArr[1];
      var o3 = optionsArr[2] == null || v.option3 === optionsArr[2];
      return o1 && o2 && o3;
    }) || null;
  }

  function computeValueAvailable(optionIndex, value, optionsArr) {
    return variants.some(function(v) {
      if (!isBuyable(v)) return false;
      if (optionIndex === 0 && v.option1 !== value) return false;
      if (optionIndex === 1 && v.option2 !== value) return false;
      if (optionIndex === 2 && v.option3 !== value) return false;
      if (optionsArr[0] != null && optionIndex !== 0 && v.option1 !== optionsArr[0]) return false;
      if (optionsArr[1] != null && optionIndex !== 1 && v.option2 !== optionsArr[1]) return false;
      if (optionsArr[2] != null && optionIndex !== 2 && v.option3 !== optionsArr[2]) return false;
      return true;
    });
  }

  function updateOptionsAvailability() {
    optionGroups.forEach(function(groupEl) {
      var idx = parseInt(groupEl.getAttribute('data-option-index'), 10);
      var buttons = groupEl.querySelectorAll('.variation-option');
      buttons.forEach(function(btn) {
        var value = btn.getAttribute('data-option-value');
        var available = computeValueAvailable(idx, value, selectedOptions);
        btn.disabled = !available || !productAvailable;
      });
    });
  }

  function updateSelectedClasses() {
    optionButtons.forEach(function(btn) {
      var idx = parseInt(btn.getAttribute('data-option-index'), 10);
      var value = btn.getAttribute('data-option-value');
      if (selectedOptions[idx] === value) {
        btn.classList.add('size-option--selected');
      } else {
        btn.classList.remove('size-option--selected');
      }
    });
  }

  function updateAddToCartUI(variant) {
    var textEl = addToCartBtn.querySelector('span');
    var available = productAvailable && isBuyable(variant);
    addToCartBtn.disabled = !available;
    if (textEl) {
      textEl.textContent = available ? translations.add_to_cart : translations.out_of_stock;
    }
    updatePriceUI(variant);
  }

  function onOptionClick(e) {
    var btn = e.currentTarget;
    if (btn.disabled) return;
    var idx = parseInt(btn.getAttribute('data-option-index'), 10);
    var value = btn.getAttribute('data-option-value');
    selectedOptions[idx] = value;
    updateSelectedClasses();
    updateOptionsAvailability();
    var match = findMatchingVariant(selectedOptions);
    if (match) {
      variantSelector.value = String(match.id);
    }
    updateAddToCartUI(match);
  }

  // Attach listeners
  optionButtons.forEach(function(btn) { btn.addEventListener('click', onOptionClick); });

  // Initialize UI, then hydrate with AJAX and re-evaluate
  function initializeUI() {
    updateOptionsAvailability();
    updateSelectedClasses();
    updateAddToCartUI(currentVariant);
  }

  initializeUI();

  // Mobile image gallery (slider + thumbnails)
  initMobileGallery();

  // Move product title into purchase column on small screens
  handleResponsiveTitlePlacement();

  // Handle form submission
  var productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();

      var formData = new FormData(this);
      var variantId = formData.get('id');
      if (!variantId) {
        alert('Please select a variant');
        return;
      }

      var selectedVariant = variants.find(function(v) { return String(v.id) === String(variantId); });
      if (!selectedVariant || !isBuyable(selectedVariant)) {
        showInlineNotice(translations.out_of_stock);
        return;
      }

      // Disable button and show loading state
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('loading');
      const originalText = addToCartBtn.querySelector('span[data-text]') ? addToCartBtn.querySelector('span[data-text]').textContent : 'Add to cart';
      if (addToCartBtn.querySelector('span[data-text]')) {
        addToCartBtn.querySelector('span[data-text]').textContent = 'Adding...';
      }

      // Check current cart quantity for this variant first
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const existingItem = cart.items.find(item => String(item.variant_id) === String(variantId));
          const currentQuantity = existingItem ? existingItem.quantity : 0;
          const maxQuantity = typeof selectedVariant.inventory_quantity === 'number' ? selectedVariant.inventory_quantity : 999;
          if (currentQuantity >= maxQuantity) {
            showInlineNotice(`Maximum quantity: ${maxQuantity} items`);
            return Promise.reject('Max quantity reached');
          }

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          showFlyingPlusOne();
          if (typeof window.refreshCart === 'function') {
            window.refreshCart();
          }
        })
        .catch(function(error) {})
        .finally(function() {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('loading');
          if (addToCartBtn.querySelector('span[data-text]')) {
            addToCartBtn.querySelector('span[data-text]').textContent = originalText;
          }
        });
    });
  }
});

// Flying +1 animation
function showFlyingPlusOne() {
  const addToCartBtn = document.querySelector('.add-to-cart-btn');
  const cartIcon = document.querySelector('.header__cart-toggle .cart-icon');
  
  if (!addToCartBtn || !cartIcon) return;
  
  // Get positions
  const buttonRect = addToCartBtn.getBoundingClientRect();
  const cartRect = cartIcon.getBoundingClientRect();
  
  // Create flying +1 element
  const flyingText = document.createElement('div');
  flyingText.textContent = '+1';
  flyingText.style.cssText = `
    position: fixed;
    left: ${buttonRect.left + buttonRect.width / 2}px;
    top: ${buttonRect.top + buttonRect.height / 2}px;
    font-size: 36px;
    font-weight: 600;
    color: var(--tasha-pink);
    pointer-events: none;
    z-index: 10000;
    transform: translate(-50%, -50%);
    text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  `;
  
  document.body.appendChild(flyingText);
  
  // Create smooth curved path animation
  const startX = buttonRect.left + buttonRect.width / 2;
  const startY = buttonRect.top + buttonRect.height / 2;
  const endX = cartRect.left + cartRect.width / 2;
  const endY = cartRect.top + cartRect.height / 2;
  
  // Calculate control point for smooth curve (parabolic)
  const controlX = (startX + endX) / 2;
  const controlY = Math.min(startY, endY) - 100; // Curve upward
  
  // Adjust end position to be a bit higher
  const adjustedEndY = endY - 30; // 7px higher than cart icon
  
  let progress = 0;
  const duration = 800; // 0.8 seconds
  const startTime = performance.now();
  
  function animate() {
    const elapsed = performance.now() - startTime;
    progress = Math.min(elapsed / duration, 1);
    
    // Smooth single-speed curve using quadratic Bezier
    const t = progress;
    const oneMinusT = 1 - t;
    
    // Quadratic Bezier curve: B(t) = (1-t)²P0 + 2(1-t)tP1 + t²P2
    const currentX = oneMinusT * oneMinusT * startX + 
                     2 * oneMinusT * t * controlX + 
                     t * t * endX;
    const currentY = oneMinusT * oneMinusT * startY + 
                     2 * oneMinusT * t * controlY + 
                     t * t * adjustedEndY;
    
    // Check if we're over the header area (assuming header is top 80px)
    const headerHeight = 80;
    const isOverHeader = currentY < headerHeight;
    
    // Smooth color transition
    if (isOverHeader) {
      // Gradually transition to white as we enter header
      const headerTransition = Math.min(1, (headerHeight - currentY) / 20);
      const redAmount = Math.floor(220 + (255 - 220) * headerTransition); // 220 -> 255
      const greenAmount = Math.floor(38 + (255 - 38) * headerTransition);  // 38 -> 255
      const blueAmount = Math.floor(38 + (255 - 38) * headerTransition);   // 38 -> 255
      flyingText.style.color = `rgb(${redAmount}, ${greenAmount}, ${blueAmount})`;
    } else {
      // Gradually transition to red as we leave header
      const contentTransition = Math.min(1, (currentY - headerHeight) / 20);
      const redAmount = Math.floor(255 - (255 - 220) * contentTransition); // 255 -> 220
      const greenAmount = Math.floor(255 - (255 - 38) * contentTransition); // 255 -> 38
      const blueAmount = Math.floor(255 - (255 - 38) * contentTransition);  // 255 -> 38
      flyingText.style.color = `rgb(${redAmount}, ${greenAmount}, ${blueAmount})`;
    }
    
    // Scale and opacity
    const scale = 1 - (progress * 0.2); // Slight scale down
    const opacity = 1 - (progress * 0.2); // Slight fade
    
    flyingText.style.transform = `translate(${currentX - startX}px, ${currentY - startY}px) scale(${scale})`;
    flyingText.style.opacity = opacity;
    
    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      // Animation complete
      document.body.removeChild(flyingText);
      updateCartCountAfterAnimation();
    }
  }
  
  requestAnimationFrame(animate);
}

function updateCartCountAfterAnimation() {
  const cartCount = document.querySelector('.cart-count');
  if (cartCount) {
    // Add bounce animation
    cartCount.classList.add('animate');
    setTimeout(() => {
      cartCount.classList.remove('animate');
    }, 500);
    
    // Fetch updated cart count
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemCount = cart.item_count || 0;
        cartCount.textContent = `(${itemCount})`;
      })
      .catch(error => {});
  }
}

function showAddToCartAnimation() {
  const addToCartBtn = document.querySelector('.add-to-cart-btn');
  if (addToCartBtn) {
    // Add animation class
    addToCartBtn.classList.add('add-to-cart-animation');
    
    // Remove animation class after animation completes
    setTimeout(() => {
      addToCartBtn.classList.remove('add-to-cart-animation');
    }, 600);
  }
}

// Store notice modal helpers
function showInlineNotice(message) {
  var box = document.getElementById('store-notice-inline');
  if (!box) return;
  box.textContent = String(message || '');
  box.style.display = 'block';
  clearTimeout(box._hideTimer);
  box._hideTimer = setTimeout(function(){
    box.style.display = 'none';
    box.textContent = '';
  }, 3000);
}

// Lightbox functionality
function initLightbox() {
  var lightbox = document.getElementById('lightbox');
  var lightboxImages = document.querySelector('.lightbox-images');
  var closeBtn = document.querySelector('.lightbox-close');
  var overlay = document.querySelector('.lightbox-overlay');
  var productImages = document.querySelectorAll('.product-gallery__item img');
  
  if (productImages.length === 0) return;
  
  // Open lightbox when clicking on product images (but not when dragging)
  var dragStartX = 0;
  var dragStartY = 0;
  var isDragging = false;
  
  productImages.forEach(function(img, index) {
    img.addEventListener('mousedown', function(e) {
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      isDragging = false;
    });
    
    img.addEventListener('mousemove', function(e) {
      var deltaX = Math.abs(e.clientX - dragStartX);
      var deltaY = Math.abs(e.clientY - dragStartY);
      if (deltaX > 5 || deltaY > 5) {
        isDragging = true;
      }
    });
    
    img.addEventListener('click', function(e) {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
        isDragging = false;
        return;
      }
      openLightbox(index);
    });
  });
  
  // Close lightbox
  function closeLightbox() {
    lightbox.classList.remove('active');
    document.body.style.overflow = 'auto';
    
    // Hide lightbox after animation completes
    setTimeout(function() {
      if (!lightbox.classList.contains('active')) {
        lightbox.style.display = 'none';
      }
    }, 300);
  }
  
  // Open lightbox and scroll to clicked image
  function openLightbox(imageIndex) {
    lightbox.style.display = 'block';
    document.body.style.overflow = 'hidden';
    
    // Trigger animation after a small delay to ensure display is set
    setTimeout(function() {
      lightbox.classList.add('active');
    }, 10);
    
    // Scroll to the clicked image after animation starts
    setTimeout(function() {
      var targetImage = document.querySelector('.lightbox-image-item[data-image-index="' + imageIndex + '"]');
      if (targetImage) {
        targetImage.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }
  
  // Event listeners
  closeBtn.addEventListener('click', closeLightbox);
  overlay.addEventListener('click', closeLightbox);
  
  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (lightbox.style.display === 'block') {
      if (e.key === 'Escape') {
        closeLightbox();
      }
    }
  });
}

// Mobile gallery slider with thumbnails (CSS-driven scroll + JS sync)
function initMobileGallery() {
  var gallery = document.querySelector('.product-gallery__scroll');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.product-thumb'));
  if (!gallery || thumbs.length === 0) return;

  var images = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__item'));
  if (images.length === 0) return;

  var mq = window.matchMedia('(max-width: 968px)');
  var activeIndex = 0;

  function setActive(index) {
    activeIndex = Math.max(0, Math.min(images.length - 1, index));
    thumbs.forEach(function(btn, i){
      if (i === activeIndex) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-current', 'true');
      } else {
        btn.classList.remove('is-active');
        btn.removeAttribute('aria-current');
      }
    });
  }

  function scrollToIndex(index) {
    if (!mq.matches) return; // only act in mobile layout
    var target = images[index];
    if (!target) return;
    slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
  }

  thumbs.forEach(function(btn, i){
    btn.addEventListener('click', function(){ scrollToIndex(i); });
  });

  // Sync on scroll (throttled with rAF)
  var ticking = false;
  function onScroll(){
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function(){
      var w = slider.clientWidth || 1;
      var idx = Math.round(slider.scrollLeft / w);
      setActive(idx);
      ticking = false;
    });
  }

  if (mq.matches) {
    setActive(0);
    slider.addEventListener('scroll', onScroll, { passive: true });
  }

  // Handle viewport changes
  mq.addEventListener ? mq.addEventListener('change', handleChange) : mq.addListener(handleChange);
  function handleChange(e) {
    if (e.matches) {
      setActive(0);
      slider.addEventListener('scroll', onScroll, { passive: true });
    } else {
      slider.removeEventListener('scroll', onScroll);
      thumbs.forEach(function(btn){ btn.classList.remove('is-active'); btn.removeAttribute('aria-current'); });
    }
  }
}

// Re-parent the product title under 970px and restore on wider screens
function handleResponsiveTitlePlacement() {
  var titleEl = document.querySelector('.product-title');
  var detailsContent = document.querySelector('.product-details .product-details__content');
  var purchaseEl = document.querySelector('.product-purchase');
  if (!titleEl || !detailsContent || !purchaseEl) return;

  // Create a placeholder to keep original position for restoration
  var placeholder = document.createElement('span');
  placeholder.style.display = 'none';
  if (!titleEl.previousElementSibling || titleEl.previousElementSibling !== placeholder) {
    detailsContent.insertBefore(placeholder, titleEl);
  }

  var mq = window.matchMedia('(max-width: 968px)');

  function applyPlacement() {
    if (mq.matches) {
      // Move into purchase as first element
      if (titleEl.parentElement !== purchaseEl) {
        purchaseEl.insertBefore(titleEl, purchaseEl.firstChild || null);
      }
    } else {
      // Restore back to original spot in details
      if (titleEl.parentElement !== detailsContent) {
        if (placeholder.parentElement === detailsContent) {
          detailsContent.insertBefore(titleEl, placeholder.nextSibling);
        } else {
          detailsContent.insertBefore(titleEl, detailsContent.firstChild || null);
        }
      }
    }
  }

  applyPlacement();
  if (mq.addEventListener) {
    mq.addEventListener('change', applyPlacement);
  } else if (mq.addListener) {
    mq.addListener(applyPlacement);
  }
}

// Gallery drag to scroll
function initGalleryDrag() {
  var gallery = document.querySelector('.product-gallery__scroll');
  if (!gallery) return;

  var isDragging = false;
  var startX = 0;
  var scrollLeft = 0;

  gallery.addEventListener('mousedown', function(e) {
    isDragging = true;
    gallery.style.cursor = 'grabbing';
    gallery.style.userSelect = 'none';
    gallery.style.scrollSnapType = 'none'; // Disable snap while dragging
    startX = e.pageX - gallery.offsetLeft;
    scrollLeft = gallery.scrollLeft;
    e.preventDefault();
    e.stopPropagation();
  });

  function snapToNearest() {
    var items = gallery.querySelectorAll('.product-gallery__item');
    if (items.length === 0) return;
    
    var currentScroll = gallery.scrollLeft;
    
    // If we're at or very close to the start (first slide), stay there
    if (currentScroll <= 10) {
      gallery.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
      return;
    }
    
    var nearestIndex = 0;
    var minDistance = Infinity;
    
    items.forEach(function(item, index) {
      var itemLeft = item.offsetLeft;
      var distance = Math.abs(currentScroll - itemLeft);
      
      if (distance < minDistance) {
        minDistance = distance;
        nearestIndex = index;
      }
    });
    
    var targetItem = items[nearestIndex];
    if (targetItem) {
      gallery.scrollTo({
        left: targetItem.offsetLeft,
        behavior: 'smooth'
      });
    }
  }

  gallery.addEventListener('mouseleave', function() {
    if (isDragging) {
      isDragging = false;
      gallery.style.cursor = 'grab';
      gallery.style.userSelect = '';
      gallery.style.scrollSnapType = 'x mandatory'; // Re-enable snap
      snapToNearest();
    }
  });

  gallery.addEventListener('mouseup', function() {
    if (isDragging) {
      isDragging = false;
      gallery.style.cursor = 'grab';
      gallery.style.userSelect = '';
      gallery.style.scrollSnapType = 'x mandatory'; // Re-enable snap
      snapToNearest();
    }
  });

  gallery.addEventListener('mousemove', function(e) {
    if (!isDragging) return;
    e.preventDefault();
    e.stopPropagation();
    var x = e.pageX - gallery.offsetLeft;
    var walk = x - startX;
    var newScrollLeft = scrollLeft - walk;
    // Ensure we can scroll to the beginning (0) and end
    var maxScroll = gallery.scrollWidth - gallery.clientWidth;
    var clampedScroll = Math.max(0, Math.min(maxScroll, newScrollLeft));
    gallery.scrollLeft = clampedScroll;
  });

  gallery.style.cursor = 'grab';
}

// Debug utilities removed to keep console clean
